import { useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { COMPANY } from "@/data";

const LINKS = [
  { label: "Usługi", href: "#uslugi" },
  { label: "Dlaczego my", href: "#dlaczego-my" },
  { label: "Realizacje", href: "#realizacje" },
  { label: "Obszar", href: "#obszar" },
  { label: "Kontakt", href: "#kontakt" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="main-navbar"
      className="fixed top-0 left-0 w-full z-50 bg-white border-b border-zinc-200 shadow-sm"
    >
      <nav className="max-w-7xl mx-auto px-6 lg:px-8 h-24 flex items-center justify-between">
        <a href="#hero" data-testid="nav-logo" className="flex items-center">
          <img
            src={COMPANY.logo}
            alt="NDNS Elektro – logo firmy elektroinstalacyjnej z Katowic"
            className="h-16 sm:h-20 w-auto"
          />
        </a>

        <div className="hidden lg:flex items-center gap-9">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              className="text-sm font-semibold text-navy hover:text-magenta transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href={COMPANY.phoneHref}
            data-testid="nav-cta-call"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-bold text-white bg-magenta hover:bg-magenta-dark transition-colors"
          >
            <Phone className="w-4 h-4" strokeWidth={2.5} />
            Zadzwoń
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="lg:hidden text-navy"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <X className="w-7 h-7" /> : <Menu className="w-7 h-7" />}
        </button>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-white border-t border-zinc-200 px-6 py-6 space-y-4">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-link-${l.href.replace("#", "")}`}
              className="block text-base font-semibold text-navy hover:text-magenta"
            >
              {l.label}
            </a>
          ))}
          <a
            href={COMPANY.phoneHref}
            data-testid="mobile-nav-cta-call"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-bold text-white bg-magenta w-full justify-center"
          >
            <Phone className="w-4 h-4" strokeWidth={2.5} /> Zadzwoń teraz
          </a>
        </div>
      )}
    </header>
  );
};
